
<div class="main" *ngIf="element && element.logoSmall && element.logoSmall.length">
  <ng-template #tippyTemplateList>
    <div class="logoBig" *ngIf="element.logoSmall && element.logoSmall.length > 0"><img src="{{element.logoBig[selectedIndex]}}" alt="{{element.productIndication}}"></div>
    <div class="brandName" [innerHTML]="element.productIndication"></div>
    <div class="applicant" [innerHTML]="element.human.designDescription"></div>
    <div class="applicant">{{element.human && element.human.applicant}}</div>
    <div class="status">{{element.human && element.human.statusDate}}</div>
    <div class="office">{{element.human && element.human.office}}</div>
  </ng-template>
  <div class="buttons" *ngIf="element.logoSmall.length>1" (click)="selected(-1)"><</div>
  <div class="img-container">
    <div *ngFor="let i of element.logoSmall; let select = index;"><img class="logo" *ngIf="select === selectedIndex" [src]="i" (click)="doCallBack()" [tippy]="tippyTemplateList"></div>
  </div>
  <div class="buttons" *ngIf="element.logoSmall.length>1" (click)="selected(1)">></div>
</div>
